import { IconWrapper, ISvgIconProps } from "@icon-park/svg/lib/runtime";

export default IconWrapper(
  "filter",
  (props: ISvgIconProps) =>
    `<svg width=${props.size} height=${props.size} viewBox="0 0 48 48" fill="none">` +
    `<path d="M18.6667 36C18.6667 37.1046 19.5621 38 20.6667 38H27.3333C28.4379 38 29.3333 37.1046 29.3333 36C29.3333 34.8954 28.4379 34 27.3333 34H20.6667C19.5621 34 18.6667 34.8954 18.6667 36ZM6 10C4.89543 10 4 10.8954 4 12C4 13.1046 4.89543 14 6 14H42C43.1046 14 44 13.1046 44 12C44 10.8954 43.1046 10 42 10H6ZM10 24C10 25.1046 10.8954 26 12 26H36C37.1046 26 38 25.1046 38 24C38 22.8954 37.1046 22 36 22H12C10.8954 22 10 22.8954 10 24Z" fill="${props.colors[0]}" />` +
    "</svg>",
);
